import { useContext } from "react";
import { getDomainValueForCode } from "../../../library/Core/SmartFunctions";
import CurrentInformation from "./CurrentInformation";
import GraduationInformation from "./GraduationInformation";
import { SmartContext } from "../../../library/Core/SmartContext";

const OutcomeInformationLayout = ({message, children}: any) => {
    const { state, dispatch } = useContext(SmartContext);
    return (
        <>
        <div className="main flex-1">
            <section className="alumni_directory_details container-fluid">
                <div className="max-1140 pt-3 pt-sm-4 px-lg-0 pb-5 overflow-hidden mx-auto">
                    <div>
                        <h1 className="mb-1 font-22 font-700">
                           Tell us the Impact of the institute
                        </h1>

                        <p className="font-18">
                            After leaving {" "}
                            <span className="font-500">{getDomainValueForCode(state?.data?.selectedInstitute?.instituteId,'INSTITUTE_DOMAIN',state)}</span>{" "}
                            in <span className="font-500">{state?.data?.selectedInstitute?.passOutYear} {" "} what career path did you choose? </span>
                        </p>

                        <hr className="opacity-25" />
                    </div>

                    <div className="py-5 max-700 w-100 mx-auto">
                        <ul className="impact-flow mb-4">

                            {/* Graduation Section */}
                            <li>
                                <div className="icon-wrapper">
                                    <div className="icon">
                                        <i className="bi bi-mortarboard-fill"></i>
                                    </div>
                                </div>
                                <GraduationInformation />
                            </li>

                            {/* Outcome Section */}
                            <li>
                                <div className="icon-wrapper">
                                    <div className="icon">
                                        <i className="bi bi-question-lg text-danger"></i>
                                    </div>
                                </div>

                                <div className="impact-flow-detail">
                                    <div className="px-3 px-sm-4 pt-3 pt-sm-4">
                                        <div className="row g-2 align-items-center">
                                            
                                            <div className="col">
                                                <h3 className="font-18 font-600">
                                                    Outcome Information Missing
                                                </h3>
                                                <p className="mb-1">
                                                    What after {state?.data?.selectedInstitute?.passOutYear}?
                                                </p>
                                                <p>
                                                    {message}
                                                </p>
                                            </div>
                                            <div className="col-auto">
                                                {state?.data?.selectedInstitute?.showOutcomeMainStep === false && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-border-gray px-3"
                                                            onClick={() =>
                                                                dispatch({
                                                                    type: 'REFRESH_DATA',
                                                                    payload: {
                                                                        data: {
                                                                            ...state.data,
                                                                            selectedInstitute: {
                                                                                ...state.data.selectedInstitute,
                                                                                showOutcomeMainStep: true,
                                                                                postProgramCompletionStatusCode: 'WORKING',
                                                                            },
                                                                        },
                                                                    },
                                                                })
                                                            }
                                                        ><span> ← Back</span>
                                                </button>
                                            )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="px-3 px-sm-4 pb-3 pb-sm-4">
                                        <div className="steps_questions mt-0">
                                            {children}
                                        </div>
                                    </div>
                                </div>
                            </li>

                            {/* Current Info Section */}
                            <li>
                                <div className="icon-wrapper">
                                    <div className="icon">
                                        <i className="bi bi-briefcase-fill"></i>
                                    </div>
                                </div>
                                <CurrentInformation />
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
        </>
    );
};

export default OutcomeInformationLayout;
